import palette from './palette';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import { SimplePaletteColorOptions } from '@mui/material';

const fontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
// The default font size of the Material Specification.
const fontSize = 14; // px
const fontWeightLight = 300;
const fontWeightRegular = 400;
const fontWeightMedium = 500;
const fontWeightSemiBold = 600;

const typography: TypographyOptions = {
  fontFamily,
  fontSize,
  fontWeightLight,
  fontWeightRegular,
  fontWeightMedium,
  h1: {
    fontFamily: '"Urbanist",' + fontFamily,
    fontSize: 30,
    lineHeight: '38px',
    fontWeight: fontWeightLight,
    letterSpacing: '0.5px',
    color: (palette?.info as SimplePaletteColorOptions)?.main
  },
  h2: {
    fontFamily,
    fontSize: 25,
    lineHeight: '32px',
    fontWeight: fontWeightLight,
    color: palette?.text?.primary
  },
  h3: {
    fontFamily,
    fontSize: 20,
    lineHeight: '26px',
    fontWeight: fontWeightLight,
    color: palette?.text?.primary
  },
  h4: {
    fontFamily,
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeightRegular,
    color: palette?.text?.primary
  },
  h5: {
    fontFamily,
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeightSemiBold,
    letterSpacing: '0.15px',
    color: palette?.text?.primary
  },
  subtitle1: {
    fontFamily,
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeightSemiBold,
    letterSpacing: '0.15px',
    color: palette?.text?.primary
  },
  subtitle2: {
    fontFamily,
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: fontWeightMedium,
    letterSpacing: '0.15px',
    color: palette?.text?.primary
  },
  body1: {
    fontFamily,
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeightRegular,
    color: palette?.text?.primary
  },
  body2: {
    fontFamily,
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: fontWeightRegular,
    letterSpacing: '0.15px',
    color: palette?.text?.primary
  },
  body3: {
    fontFamily,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeightRegular,
    letterSpacing: '0.15px',
    color: palette?.text?.primary
  },
  caption: {
    fontFamily,
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: fontWeightRegular,
    letterSpacing: '0.3px',
    color: palette?.text?.secondary
  }
};

export default typography;
